const Permissions = {
  ViewAttachment: 'attachment.view',
  CreateAttachment: 'attachment.create',
  ViewDraft: 'draft.view',
  CreateDraft: 'draft.create',
  EditDraft: 'draft.edit',
  PublishDraft: 'draft.publish',
  DeleteDraft: 'draft.delete',
  ViewPublication: 'publication.view',
  EditPublication: 'publication.edit',
  UnpublishPublication: 'publication.unpublish',
  DeletePublication: 'publication.delete',
};

export function canCreatePublication(permissions) {
  return permissions?.[Permissions.CreateDraft];
}

export function canEditPublication(permissions, publication) {
  return (
    (publication?.published && permissions?.[Permissions.EditPublication]) ||
    (publication?.published === false && permissions?.[Permissions.EditDraft])
  );
}

export function canDeletePublication(permissions, publication) {
  return (
    (publication?.published && permissions?.[Permissions.DeletePublication]) ||
    (publication?.published === false && permissions?.[Permissions.DeleteDraft])
  );
}

export function canViewDraft(permissions) {
  return permissions?.[Permissions.ViewDraft];
}

export function canViewAttachment(permissions) {
  return permissions?.[Permissions.ViewAttachment];
}

export function canChangePublicationStatus(permissions) {
  return (
    permissions?.[Permissions.PublishDraft] &&
    permissions?.[Permissions.UnpublishPublication]
  );
}
